import { apiFetch, parseApiError } from './client';

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  const entries = {
    start: filters.start,
    end: filters.end,
    asOf: filters.asOf,
    topPercent: filters.topPercent,
    limit: filters.limit,
    accountId: filters.accountId,
  };

  Object.entries(entries).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });

  return params.toString();
}

export async function fetchCustomerSegments(filters = {}) {
  const query = buildQuery(filters);
  const path = query ? `/api/customer-segments?${query}` : '/api/customer-segments';
  const response = await apiFetch(path, { method: 'GET' });
  if (!response.ok) {
    throw new Error(await parseApiError(response, 'Failed to load customer segments'));
  }
  return response.json();
}

export async function syncCustomerSegmentsToKlaviyo(filters = {}) {
  const query = buildQuery(filters);
  const path = query
    ? `/api/customer-segments/sync/klaviyo?${query}`
    : '/api/customer-segments/sync/klaviyo';
  const response = await apiFetch(path, { method: 'POST' });
  if (!response.ok) {
    throw new Error(await parseApiError(response, 'Failed to sync customer segments to Klaviyo'));
  }
  return response.json();
}
